import { useState } from 'react';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import { useTranslation } from 'react-i18next';
import AddWorkshop from './AddWorkshop';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import EditFormDepartments from '../../../HR/Departments/EditDepartments/EditFormDepartments';

import useGetOrganizations from '../../../../hooks/HR/use-get-organizations';
import useLookupOrgClass from '../../../../hooks/Lookups/use-Lookup-OrgClass';
import NtxTable from '../../../../components/DataTable/NtxTable';
import Loading from '../../../../components/Shared/Loader/Loading';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const Index = () => {
  const { HasPermission } = usePermissions();
  const [Show, setShow] = useState(false);
  const [id, setId] = useState('');
  const { t, i18n } = useTranslation();
  const { Organizations, loading } = useGetOrganizations();
  const { dataORGCLASS } = useLookupOrgClass();

  const columns = [
    { title: t('Name'), key: 'Name', className: 'w-25' },
    { title: t('location'), key: 'location', className: 'w-25' },
    { title: t('Classification'), key: 'Classification', className: 'w-25', sortable: false },
    { title: t(''), key: 'action', className: 'text-end w-25', sortable: false }
  ];

  const tableData = Organizations?.filter((f: any) => f.type === '160')?.map((item: any) => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,
      location: i18n.language === 'en' ? item.locationName : item.locationName2,
      Classification: item.organizationInformation ? (
        <ul className='list-unstyled mb-0 p-0 d-flex flex-wrap gap-1'>
          {item?.organizationInformation?.split(',')?.map((info: any, idx: any) => (
            <li key={idx} className='badge border border-theme text-theme px-2 pt-5px pb-5px rounded fs-12px me-1'>
              {dataORGCLASS?.find((f: any) => f.value === info)?.label || ''}
            </li>
          ))}
        </ul>
      ) : (
        <span className='text-muted'> </span>
      ),
      action: (
        <>
          <button
            hidden={!HasPermission('FleetWorkshopEdit')}
            type='button'
            className='btn btn-sm btn-outline-theme  me-1'
            // onClick={() => Navigate(`${item.id}/Edit`)} //Departments/:id/Edit
            // hidden={hiddenEdit}
            data-bs-toggle='modal'
            data-bs-target='#modalEditWorkShop'
            onClick={() => setId(item.id)}
          >
            <i className='far fa-lg fa-fw me-2 fa-edit'></i>
            {t('Button.Edit')}
          </button>
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Workshops',
              link: null
            }
          ]}
          PageName='Workshops'
        />
        <div className='ms-auto'>
          <a
            hidden={!HasPermission('FleetAddWorkshop')}
            href='#/'
            className='btn me-1 btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalِAddWorkShop'
            onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('AddWorkshop')}
          </a>
        </div>
      </div>

      <Card>
        <Loading loading={loading}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddWorkshop')} id='modalِAddWorkShop' size='lg'>
        {Show && <AddWorkshop />}
      </ModalComponent>
      <ModalComponent title={t('EditWorkshop')} id='modalEditWorkShop' size='lg'>
        {id && <EditFormDepartments id={id} type='160' />}
      </ModalComponent>
    </div>
  );
};

export default Index;
